<template>
    <section class="corsair">
        <div class="corsair-header">
            <img
            src="/static/assets/images/CorsairLogoSprite.png"
            alt="Corsair"
            />
            <h2>iCUE RGB Integration</h2>
            <hr />
        </div>
        <div class="corsair-info">
            <p>We've partnered with <a href="https://www.corsair.com/us/en/" target="_blank">CORSAIR</a> to bring iCUE RGB integration to Dwerve! Now you can play with full immersion! Watch your CORSAIR PC Gaming Accessories light up in response to the vast world and game events like taking damage and completing quests!</p>
            <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/t9rLZmmBWKA"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
    </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
section.corsair {
  background: url(/static/assets/images/Dwerve-Brick-Texture.png);
  padding: 90px 0px;
  visibility: visible;
  top: 0;
  position: relative;
  border-top: 9px double #0f0a06;
}

.corsair-header h2 {
  font-family: Grandmaster;
  padding: 0px 30px;
  line-height: 1.4;
  z-index: 1;
  font-size: 40px;
  color: #ffffff;
  text-align: center;
  text-shadow: -2.4px -2.4px 0 #1d1a44, -2.4px -1.4px 0 #1d1a44,
    -2.4px -0.4px 0 #1d1a44, -2.4px 0.6px 0 #1d1a44, -2.4px 1.6px 0 #1d1a44,
    -2.4px 2.6px 0 #1d1a44, -1.4px -2.4px 0 #1d1a44, -1.4px -1.4px 0 #1d1a44,
    -1.4px -0.4px 0 #1d1a44, -1.4px 0.6px 0 #1d1a44, -1.4px 1.6px 0 #1d1a44,
    -1.4px 2.6px 0 #1d1a44, -0.4px -2.4px 0 #1d1a44, -0.4px -1.4px 0 #1d1a44,
    -0.4px -0.4px 0 #1d1a44, -0.4px 0.6px 0 #1d1a44, -0.4px 1.6px 0 #1d1a44,
    -0.4px 2.6px 0 #1d1a44, 0.6px -2.4px 0 #1d1a44, 0.6px -1.4px 0 #1d1a44,
    0.6px -0.4px 0 #1d1a44, 0.6px 0.6px 0 #1d1a44, 0.6px 1.6px 0 #1d1a44,
    0.6px 2.6px 0 #1d1a44, 1.6px -2.4px 0 #1d1a44, 1.6px -1.4px 0 #1d1a44,
    1.6px -0.4px 0 #1d1a44, 1.6px 0.6px 0 #1d1a44, 1.6px 1.6px 0 #1d1a44,
    1.6px 2.6px 0 #1d1a44, 2.6px -2.4px 0 #1d1a44, 2.6px -1.4px 0 #1d1a44,
    2.6px -0.4px 0 #1d1a44, 2.6px 0.6px 0 #1d1a44, 2.6px 1.6px 0 #1d1a44;
  margin-top: 0;
}

.corsair-header hr {
  max-width: 1280px;
  border-top: 2px solid #21262a;
  margin-top: 12px;
  margin-bottom: 20px;
  width: 80%;
}

section.corsair p {
  color: #fff;
  font-size: 18px;
  padding-bottom: 20px;
}

.corsair-info iframe {
    width: 100%;
    height: 450px;
}

.corsair-header img {
    width: 130px;
    margin-bottom: 20px;
}
.corsair-info {
    max-width: 860px;
    margin: auto;
    padding: 0px 20px;
}
.corsair-header {
    text-align: center;
}

@media only screen and (max-width: 580px) {
  .corsair-info iframe {
    height: 300px;
}
}
</style>


// WEBPACK FOOTER //
// src/views/Home/Corsair.vue